import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../../features/blogs/blogsSlice";
import Loading from "../UI/Loading";
import BlogCard from "./BlogCard";

const BlogList = () => {
  const { blogs, isLoading, isError, error } = useSelector(
    (state) => state.blogs
  );
  const { sortStatus, filterStatus } = useSelector((state) => state.filter);

  const dispatch = useDispatch();

  const sortBlogs = (a, b) => {
    switch (sortStatus) {
      case "most_liked":
        return b.likes - a.likes;

      case "newest":
        return new Date(b.createdAt) - new Date(a.createdAt);

      default:
        return 0;
    }
  };

  const filterBlogs = (blog) => {
    return filterStatus === "saved" ? blog.isSaved : blog;
  };

  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);

  // decide what to render
  let content;

  if (isLoading) content = <Loading />;

  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && blogs?.length === 0)
    content = <div className="col-span-12">No Blogs Found!</div>;

  if (!isError && !isLoading && blogs?.length > 0)
    content = blogs
      .filter(filterBlogs)
      .sort(sortBlogs)
      .map((blog) => <BlogCard blog={blog} key={blog.id} />);

  return (
    <main className="post-container" id="lws-postContainer">
      {content}
    </main>
  );
};

export default BlogList;
